// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__IQW_G","title":"Header_title__2Kgwt"};